import React, { useState } from 'react';
import { FiCheck, FiBook, FiAward, FiFileText } from 'react-icons/fi';
import DropFixImage from '../DropFixImage';
import CursoComboBox from '../CursoComboBox';
import ComprovanteUpload from '../ComprovanteUpload';
import { escolaridadeAll } from '../../utils';

// Etapa "Dados da carteirinha" do checkout: instituição, curso, escolaridade,
// foto e comprovante de matrícula. Coletado ANTES de pagar pra carteirinha já
// nascer completa. Chama onConfirmar({ instituicao, curso, escolaridade, foto,
// comprovante, comprovanteMimeType }) quando válido.

export default function DadosCarteirinhaForm({ initial, loading = false, onConfirmar, textoBotao = 'Continuar' }) {
    const [instituicao, setInstituicao] = useState(initial?.instituicao || '');
    const [curso, setCurso] = useState(initial?.curso || '');
    const [escolaridade, setEscolaridade] = useState(initial?.escolaridade || '');
    const [foto, setFoto] = useState(initial?.foto || null);
    // Comprovante de matrícula: PDF ou imagem. Obrigatório no lado do aluno.
    const [comprovante, setComprovante] = useState(
        initial?.comprovante && initial?.comprovanteMimeType
            ? { arquivo: initial.comprovante, mimeType: initial.comprovanteMimeType }
            : null
    );
    const [erro, setErro] = useState(null);

    const confirmar = () => {
        if (!instituicao.trim() || !curso.trim() || !escolaridade || !foto) {
            setErro('Preencha instituição, curso, escolaridade e anexe sua foto.');
            return;
        }
        if (!comprovante) {
            setErro('Anexe seu comprovante de matrícula (PDF ou imagem).');
            return;
        }
        setErro(null);
        onConfirmar({
            instituicao: instituicao.trim(),
            curso: curso.trim(),
            escolaridade,
            foto,
            comprovante: comprovante.arquivo,
            comprovanteMimeType: comprovante.mimeType,
        });
    };

    return (
        <div style={styles.wrap}>
            <div style={styles.header}><FiBook size={17} /> <span>Dados da carteirinha</span></div>

            <label style={styles.label}>Instituição de ensino</label>
            <input
                type="text" value={instituicao} disabled={loading}
                onChange={(e) => setInstituicao(e.target.value)}
                placeholder="Ex: UFMG, USP, FGV..." style={styles.input}
            />

            <label style={styles.label}>Curso</label>
            <CursoComboBox
                value={curso}
                onChange={setCurso}
                disabled={loading}
                placeholder="Selecione ou digite seu curso"
                style={styles.input}
            />

            <label style={styles.label}><FiAward size={12} /> Escolaridade</label>
            <select
                value={escolaridade} disabled={loading}
                onChange={(e) => setEscolaridade(e.target.value)}
                style={styles.input}
            >
                <option value="">Selecione o nível</option>
                {escolaridadeAll.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
            </select>

            <label style={{ ...styles.label, marginTop: '0.9rem' }}>Sua foto</label>
            <DropFixImage value={foto} onChange={setFoto} />

            <label style={{ ...styles.label, marginTop: '0.9rem' }}>
                <FiFileText size={12} /> Comprovante de matrícula
            </label>
            <ComprovanteUpload
                value={comprovante}
                onChange={setComprovante}
                disabled={loading}
            />

            {erro && <div style={styles.erro}>{erro}</div>}

            <button type="button" onClick={confirmar} disabled={loading} style={styles.btn}>
                <FiCheck size={15} /> {textoBotao}
            </button>
        </div>
    );
}

const styles = {
    wrap: {
        background: '#ffffff', border: '1px solid #E2E8F0', borderRadius: 12,
        padding: '1rem', marginBottom: '1rem',
    },
    header: {
        display: 'flex', alignItems: 'center', gap: 8,
        fontWeight: 700, color: '#0F172A', marginBottom: '0.75rem', fontSize: '0.95rem',
    },
    label: {
        display: 'flex', alignItems: 'center', gap: 5,
        fontSize: '0.76rem', fontWeight: 600, color: '#475569',
        margin: '0.6rem 0 0.25rem',
    },
    input: {
        width: '100%', padding: '0.65rem 0.7rem', border: '1px solid #E2E8F0',
        borderRadius: 10, fontSize: '0.9rem', fontFamily: 'inherit',
        color: '#0F172A', background: '#FFFFFF', boxSizing: 'border-box', outline: 'none',
    },
    erro: {
        marginTop: '0.6rem', color: '#9F1239', fontSize: '0.82rem',
        padding: '0.5rem 0.75rem', background: '#FFF1F2', border: '1px solid #FECDD3', borderRadius: 8,
    },
    btn: {
        width: '100%', marginTop: '0.9rem', padding: '0.8rem', borderRadius: 10, border: 'none',
        cursor: 'pointer', background: 'linear-gradient(135deg,#059669,#10B981)',
        color: '#fff', fontWeight: 700, fontSize: '0.9rem', fontFamily: 'inherit',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    },
};
